import axios from '@/utils/request'
import utils from '@/utils/index.js'
var Qs = require('qs')

export default {

  states_all: ['newly', 'gived', 'accepted', 'holding', 'holded', 'partially', 'finished', 'canceled', 'untrod'],
  passRange: [
    { label: '1天', key: 'pass1', condition: { passRangeStart: 1, passRangeEnd: 1 } },
    { label: '2天', key: 'pass2', condition: { passRangeStart: 2, passRangeEnd: 2 } },
    { label: '3天', key: 'pass3', condition: { passRangeStart: 3, passRangeEnd: 3 } },
    { label: '4-7天', key: 'pass4', condition: { passRangeStart: 4, passRangeEnd: 7 } },
    { label: '全部', key: 'pas-all', condition: { passRangeStart: 1, passRangeEnd: 100 } }
  ],
  nearRange: [
    { label: '今天', key: 'near-today', condition: { nearRangeStart: utils.formatDate(utils.beginOfDay(new Date())) + ' 00:00:00', nearRangeEnd: utils.formatDate(utils.endOfDay(new Date())) + ' 23:59:59' } },
    { label: '明天', key: 'near-tomorrow', condition: { nearRangeStart: utils.formatDate(utils.beginOfDay(utils.nextNDay(1))) + ' 00:00:00', nearRangeEnd: utils.formatDate(utils.endOfDay(utils.nextNDay(1))) + ' 23:59:59' } },
    { label: '后天', key: 'near-datmr', condition: { nearRangeStart: utils.formatDate(utils.beginOfDay(utils.nextNDay(2))) + ' 00:00:00', nearRangeEnd: utils.formatDate(utils.endOfDay(utils.nextNDay(2))) + ' 23:59:59' } },
    { label: '4-7天', key: 'near-4-7', condition: { nearRangeStart: utils.formatDate(utils.beginOfDay(utils.nextNDay(3))) + ' 00:00:00', nearRangeEnd: utils.formatDate(utils.endOfDay(utils.nextNDay(6))) + ' 23:59:59' } },
    { label: '本周', key: 'near-week', condition: { nearRangeStart: utils.formatDate(utils.beginOfDay(utils.beginOfThisWeek())) + ' 00:00:00', nearRangeEnd: utils.formatDate(utils.endOfThisWeek()) + ' 23:59:59' } }
  ],
  // 2020-10-17
  search(params) {
    return axios.get('/purchases?' + Qs.stringify(params, { arrayFormat: 'repeat' }));
  },
  // 2021-01-09
  pendingRequisitionSearch(params) {
    return axios.get('/purchases/pending-requisitions?' + Qs.stringify(params, { arrayFormat: 'repeat' }))
  },
  // 2021-01-16
  materialAccountingSearch(params) {
    return axios.get('/purchases/material-accounting-search?' + Qs.stringify(params, { arrayFormat: 'repeat' }))
  },

  // 2020-10-28
  create(params) {
    return axios.post('/purchases', params)
  },
  // 2021-01-13
  insertBatch(params) {
    return axios.post('/purchases/insert-batch', params)
  },
  // 2020-10-28
  history(params) {
    return axios.get('/purchases/history', params);
  },
  // 2020-10-16
  findByOrderId(orderId) {
    return axios.get('/purchases/find-by-order-id/' + orderId);
  },
  // 2020-10-27
  hurry(id) {
    return axios.put('/purchases/' + id + '/hurry')
  },
  // 2020-12-29
  update(id, params) {
    return axios.put('/purchases/' + id, params)
  },
  // 2020-10-27
  updateSettleRemark(params) {
    return axios.put('/purchases/update-settle-remark', params)
  },
  // 2022-08-19
  updatePurchaseRemark(params) {
    return axios.put('/purchases/update-purchase-remark', params)
  },
  // 2020-10-27
  updateFlags(params) {
    return axios.put('/purchases/update-flags', params)
  },
  // 2020-10-27
  delete(id) {
    return axios.delete('/purchases/' + id)
  },
  // 2020-10-27
  exportExcel(params) {
    return axios.get('/purchases/export-excel?' + Qs.stringify(params, { arrayFormat: 'repeat' }));
  },
  // 2020-10-27
  print(params) {
    return axios.put('/purchases/print', params);
  },
  // 2020-10-27
  place(params) {
    return axios.put('/purchases/place', params)
  },
  // 2021-05-14
  batchPlace(params) {
    return axios.put('/purchases/batch-place', params)
  },
  //2020-10-27
  settle(id) {
    return axios.put('/purchases/' + id + '/settle')
  },
  //2023-03-11
  cancelSettle(id) {
    return axios.put('/purchases/' + id + '/cancel-settle')
  },
  //2020-10-27
  retrieve(id) {
    return axios.put('/purchases/' + id + '/retrieve')
  },
  //2020-10-27
  cancel(id) {
    return axios.put('/purchases/' + id + '/cancel')
  },
  //2020-12-15
  returnBack(id, params) {
    return axios.put('/purchases/' + id + '/return-back', params)
  },
  //2020-10-28
  findBySerialNo(params) {
    return axios.get('/purchases/find-by-serial-no', params)
  },

  //2020-10-30
  copy(id, params) {
    return axios.put('/purchases/' + id + '/copy', params)
  },
  // 2020-11-28
  newlyCount() {
    return axios.get('/purchases/newly-count');
  },

  // 2020-12-09
  unSettle(params) {
    return axios.get('/purchases/un-settle', params);
  },

  // 2020-12-10
  purchaseQtyCount() {
    return axios.get('/purchases/purchase-qty-count');
  },
  // 2020-12-10
  nearQtys() {
    const rangesTxts = this.nearRange.map(pr => pr.condition.nearRangeStart + '---' + pr.condition.nearRangeEnd)
    return axios.get('/purchases/near-qtys?' + Qs.stringify({ dates: rangesTxts }, { arrayFormat: 'repeat' }));
  },
  // 2020-12-10
  passQtys() {
    const rangesTxts = this.passRange.map(pr => pr.condition.passRangeStart + '-' + pr.condition.passRangeEnd)
    return axios.get('/purchases/pass-qtys?' + Qs.stringify({ passRange: rangesTxts }, { arrayFormat: 'repeat' }));
  },
  // 2021-01-13
  findBySerialNos(params) {
    return axios.post('/purchases/find-by-serial-nos', params)
  },
  // 2021-01-21
  forceSearch(params) {
    return axios.get('/purchases/force-search?' + Qs.stringify(params, { arrayFormat: 'repeat' }));
  },
  //2021-01-21
  batchForceReceive(params) {
    return axios.put('/purchases/batch-force-receive', params)
  },
  // 2021-01-21
  changeSpecsForeceReceive(params) {
    return axios.put('/purchases/change-specs-forece-receive', params)
  },

  // 2021-02-26
  findReceiveRecord(id) {
    return axios.get('/purchases/' + id + '/find-receive-record');
  },
  // 2021-02-14
  findByUuid(params) {
    return axios.get('/purchases/find-by-uuid', params);
  },

  // 2021-03-11
  detailReport(params) {
    return axios.get('/purchases/detail-report?' + Qs.stringify(params, { arrayFormat: 'repeat' }));
  },
  // 2021-03-11
  detailReportExportExcel(params) {
    return axios.get('/purchases/detail-report-export-excel?' + Qs.stringify(params, { arrayFormat: 'repeat' }));
  },
  // 2021-04-17
  updatePrice(params) {
    return axios.put('/purchases/update-price', params);
  },
  // 2021-05-27
  batchUpdatePrice(params) {
    return axios.put('/purchases/batch-update-price', params);
  },
  // 2021-05-22
  trackSupplierInfos(id) {
    return axios.get('/purchases/' + id + '/track-supplier-infos');
  },
  // 2021-09-01
  findWithProductByUuids(params) {
    return axios.post('/purchases/find-with-product-by-uuids', params)
  },

  // 2021-11-17
  supplierOverReport(params) {
    return axios.get('/purchases/supplier-over-report?' + Qs.stringify(params, { arrayFormat: 'repeat' }));
  },
  // 2021-11-17
  supplierOverReportDetail(params) {
    return axios.get('/purchases/supplier-over-report-detail?' + Qs.stringify(params, { arrayFormat: 'repeat' }));
  },
  // 2021-11-17
  supplierOverReportDetailExportExcel(params) {
    return axios.get('/purchases/supplier-over-report-detail-export-excel?' + Qs.stringify(params, { arrayFormat: 'repeat' }));
  },

  // 2023-06-25
  pendingRequisitionsTotalCount() {
    return axios.get('/purchases/pending-requisitions-total-count');
  },
  // 2023-06-25
  pendingRequisitionsCount() {
    return axios.get('/purchases/pending-requisitions-count');
  },
  // 2020-10-27
  findById(id) {
    return axios.get('/purchases/' + id);
  },
}

